import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom";
// import { createChart, CrosshairMode } from "lightweight-charts";
import { createChart, CrosshairMode } from "../../modules/lightweight-charts/index";

import moment from "moment/moment";

let candleSeries = null;
let volumeSeries = null;
let areaSeries = null;

function Chart({
  ohlcs,
  type,
  limit,
}) {
  const chartContainerRef = useRef();
  const chart = useRef();
  const resizeObserver = useRef();
  const datas = [];

  useEffect(() => {
    chart.current = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: chartContainerRef.current.clientHeight,
      layout: {
        backgroundColor: "#253248",
        textColor: "rgba(255, 255, 255, 0.9)",
      },
      grid: {
        vertLines: {
          color: "#334158",
        },
        horzLines: {
          color: "#334158",
        },
      },
      crosshair: {
        mode: CrosshairMode.Normal,
      },
      priceScale: {
        borderColor: "#485c7b",
      },
      rightPriceScale: {
        scaleMargins: {
          top: 0.3,
          bottom: 0.25,
        },
        borderVisible: false,
      },
      timeScale: {
        borderColor: "#485c7b",
        timeVisible: true,
      },
    });

    // console.log(chart.current);

    candleSeries = chart.current.addCandlestickSeries({
      upColor: "#4bffb5",
      downColor: "#ff4976",
      borderDownColor: "#ff4976",
      borderUpColor: "#4bffb5",
      wickDownColor: "#838ca1",
      wickUpColor: "#838ca1",
      priceFormat: {
        // minMove: 1,
        precision: 12,
      },
    });

    areaSeries = chart.current.addAreaSeries({
      topColor: "rgba(38,198,218, 0.56)",
      bottomColor: "rgba(38,198,218, 0.04)",
      lineColor: "rgba(38,198,218, 1)",
      lineWidth: 2,
      priceFormat: {
        // minMove: 1,
        precision: 12,
      },
    });

    volumeSeries = chart.current.addHistogramSeries({
      color: "#182233",
      lineWidth: 2,
      priceFormat: {
        type: "volume",
      },
      overlay: true,
      scaleMargins: {
        top: 0.8,
        bottom: 0,
      },
      priceFormat: {
        // minMove: 1,
        precision: 12,
      },
    });
  }, []);

  useEffect(() => {
    var unix_zone =
      moment.utc("1988-04-12 00:00").unix() - moment("1988-04-12 00:00").unix();

    var unix_minute = type * 60;
    var unix_today = moment()
      .startOf("day")
      .unix();

    var unix_delta = moment().unix() - unix_today;
    var unix_count = (unix_delta / unix_minute) | 0;

    const candleData = [];
    const areaData = [];
    const volumeData = [];

    for (let i = 0; i < limit; i++) {
      const unix = unix_today + (unix_count + 1 - limit + i) * unix_minute;
      const targetAry = ohlcs ? ohlcs.filter((_) => _.time == unix) : [];
      let candle = {};
      let area = {};
      let volume = {};

      // if (targetAry.length == 0) continue

      if (targetAry.length == 0) {
        candle = { time: unix };
        volume = { time: unix };
        area = { time: unix };
      } else {
        candle = {
          time: Number(targetAry[0].time),
          open: Number(targetAry[0].open),
          high: Number(targetAry[0].high),
          low: Number(targetAry[0].low),
          close: Number(targetAry[0].close),
        };
        area = {
          time: Number(targetAry[0].time),
          value: Number(targetAry[0].close),
        };
        const sign =
          Number(targetAry[0].buy_volume) - Number(targetAry[0].sell_volume);

        volume = {
          time: Number(targetAry[0].time),
          value: Math.abs(sign),
          color: sign > 0 ? "rgba(0, 150, 136, 0.8)" : "rgba(255,82,82, 0.8)",
        };
      }

      // ローカルタイムスタンプへ
      candle.time = candle.time + unix_zone;
      volume.time = volume.time + unix_zone;
      candleData.push(candle);
      // areaData.push(area);
      volumeData.push(volume);
    }

    candleSeries.setData(candleData);
    // areaSeries.setData(areaData);
    volumeSeries.setData(volumeData);
  }, [ohlcs]);

  // Resize chart on container resizes.
  useEffect(() => {
    resizeObserver.current = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      chart.current.applyOptions({ width, height });
      setTimeout(() => {
        chart.current.timeScale().fitContent();
      }, 0);
    });

    resizeObserver.current.observe(chartContainerRef.current);

    return () => resizeObserver.current.disconnect();
  }, []);

  return (
    <div
      style={{
        margin: 0,
        height: "50vh",
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <div ref={chartContainerRef} style={{ flex: 1 }} />
    </div>
  );
}

export default Chart;

// から埋めはいらない
// for (let i = 0; i < limit; i++) {
//   const unix = unix_today + (unix_count + 1 - limit + i) * unix_minute;
//   const targetAry = ohlcs ? ohlcs.filter((_) => _.time == unix) : [];
//   let candle = {};
//   let area = {};
//   let volume = {};
//   if (targetAry.length == 0) {
//     candle = { time: unix };
//     volume = { time: unix };
//     area = { time: unix };
//   } else {
//     candle = {
//       time: Number(targetAry[0].time),
//       open: Number(targetAry[0].open),
//       high: Number(targetAry[0].high),
//       low: Number(targetAry[0].low),
//       close: Number(targetAry[0].close),
//     };
//     area = {
//       time: Number(targetAry[0].time),
//       value: Number(targetAry[0].close),
//     };
//     const sign =
//       Number(targetAry[0].buy_volume) - Number(targetAry[0].sell_volume);

//     volume = {
//       time: Number(targetAry[0].time),
//       value: Math.abs(sign),
//       color: sign < 0 ? "rgba(0, 150, 136, 0.8)" : "rgba(255,82,82, 0.8)",
//     };
//   }

//   // ローカルタイムスタンプへ
//   candle.time = candle.time + unix_zone;
//   volume.time = volume.time + unix_zone;
//   candleData.push(candle);
//   areaData.push(area);

//   volumeData.push(volume);
// }
